import { Component, ElementRef, EventEmitter, Input, OnInit, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { DynamicFiltersModulesDescriptions } from 'app/enums/dynamic-filters-modules.enum';
import { Modules } from 'app/enums/modules.enum';
import { ComplaintType } from 'app/models/complaints/complaint.interface';
import { DataFiltered, StepFilteredDto, StepResultDto } from 'app/models/dynamic-filters/dynamic-filters.model';
import { Item } from 'app/models/item.inferface';
import { WorkflowTypeByModuleDto } from 'app/models/workflow/workflow.interface';
import { QUESTION_TYPES } from 'app/modules/app-form/form-question.directive';
import { AppFormComponent } from 'app/modules/app-form/form-test/app-form.component';
import { DataSourceService } from 'app/services/data-source.service';
import { DynamicFiltersService } from 'app/services/dynamic-filters.service';
import { switchMap, tap } from 'rxjs/operators';

@Component({
  selector: 'app-dynamic-filters',
  templateUrl: './dynamic-filters.component.html',
  styleUrls: ['./dynamic-filters.component.scss']
})
export class DynamicFiltersComponent implements OnInit {

  @ViewChildren('formComponent') formComponents: QueryList<AppFormComponent>// AppFormComponent;
  
  @Input() moduleSelectData: Item[] = [];
  @Input() selectedModule: DynamicFiltersModulesDescriptions = null;
  @Input() workflowsSelectData: Item[] = [];
  @Input() entityModule: DynamicFiltersModulesDescriptions = null;
  @Input() usePreviousData: boolean = false;
  @Input() prevFilters: StepFilteredDto;
  @Input() currentWorkflowSelected: number;
  @Input() currentStepSelected: number;
  @Input() filtersLabel: string;
  @Input() loadingSearch: boolean;
  @Input() selectStepLabel: string;

  @Output() onModuleSelected: EventEmitter<number> = new EventEmitter();
  @Output() stepFiltered: EventEmitter<DataFiltered> = new EventEmitter();
  @Output() onClearFilters: EventEmitter<{filtersClear: boolean, dataStepFiltered: DataFiltered}> = new EventEmitter();
  @Output() onWorflowSelected: EventEmitter<number> = new EventEmitter();
  @Output() onStepSelected: EventEmitter<number> = new EventEmitter();
  @Output() onClearAllFilters: EventEmitter<boolean> = new EventEmitter();

  dynamicFiltersModulesDescriptions = DynamicFiltersModulesDescriptions;
  public MODULES = Modules;
  dynamicFiltersModules = [
    {
      moduleId: Modules.Alerts,
      description: DynamicFiltersModulesDescriptions.Alerts
    },
    {
      moduleId: Modules.Case,
      description: DynamicFiltersModulesDescriptions.Cases
    },
    {
      moduleId: Modules.Complaints,
      description: DynamicFiltersModulesDescriptions.Complaint
    }];
    
  module = {moduleId: 0, description: ''};
  complaintFormsResult = [];
  complaintSubtype;
  @Input()
  workflowTypeByModule: WorkflowTypeByModuleDto[] = [];
  workflowTypeIds: number[] = [];

  moduleSelectorForm: UntypedFormGroup;
  selectorForm: UntypedFormGroup;
  selectorStepForm: UntypedFormGroup;

  loadingData: boolean = false;

  stepsResult: StepResultDto[] = [];
  useOneStep: boolean = false;

  specialCharacters: string[] = [`'`,`"`,'!','%','^','*','(',')','-','/','||'];

  constructor(
    private datasourceService: DataSourceService,
    private dynamicFilterService: DynamicFiltersService,
    private formBuilder: UntypedFormBuilder,
  ) { }

  ngOnInit(): void {

    // this.datasourceService.getWorkflowTypeByModule().subscribe(res => this.workflowTypeByModule = res);
      
    this.createForms();
    this.suscribeForms();
  }

  ngOnChanges(){
    if(this.workflowsSelectData?.length === 1 && !this.usePreviousData){
      setTimeout(()=>{
        if(!this.selectorForm?.get('workflowSelect')?.value){
          this.selectorForm.get('workflowSelect').setValue(this.workflowsSelectData[0].id);
        }
      },500);
    }
  }

  ngAfterViewInit(){ }

  ngAfterContentInit(){
    if(this.selectedModule){
      this.entityModule = this.selectedModule;
    }

    if(this.usePreviousData){
      this.selectorForm.get('workflowSelect').setValue(this.currentWorkflowSelected, {emitEvent:true});
      this.selectorStepForm.get('stepSelected').setValue(this.currentStepSelected, {emitEvent:true});

      // console.log(this.moduleSelectData);
      this.moduleSelectData.map(x => {
        if(x.description == this.entityModule){
          // console.log(this.entityModule);
          if(this.entityModule == DynamicFiltersModulesDescriptions.Complaint){
            this.module.moduleId = Modules.Complaints;
            this.moduleSelectorForm.get('moduleSelect').setValue(this.moduleSelectData.find(m => m.description == this.entityModule));
          }else if(this.entityModule == DynamicFiltersModulesDescriptions.Alerts){
            this.module.moduleId = Modules.Alerts;
            this.moduleSelectorForm.get('moduleSelect').setValue(this.moduleSelectData.find(m => m.description == this.entityModule));
          }else if(this.entityModule == DynamicFiltersModulesDescriptions.Cases){
            this.module.moduleId = Modules.Case;
            this.moduleSelectorForm.get('moduleSelect').setValue(this.moduleSelectData.find(m => m.description == this.entityModule));
          }
        }
      });
      
      if(this.module.moduleId === Modules.Complaints){
        this.selectorForm.get('workflowSelect').setValue(this.currentWorkflowSelected);
        this.complaintFormsResult.push(this.prevFilters.formDto);
      }else if(this.module.moduleId === Modules.Alerts){
      }else if(this.module.moduleId === Modules.Case){
        this.selectorForm.get('workflowSelect').setValue(this.currentWorkflowSelected);
        
        console.log(this.prevFilters);
      }
    }

    this.reloadWorkflowData();
  }

  reloadWorkflowData(){
    if(this.selectedModule){
      if(this.module){
        if(this.selectedModule == DynamicFiltersModulesDescriptions.Complaint){
          this.module.moduleId = Modules.Complaints;
          this.dynamicFilterService.getComplaintTypes().subscribe(
           res => this.workflowsSelectData = res
          );
        }else if(this.selectedModule == DynamicFiltersModulesDescriptions.Cases){
          this.module.moduleId = Modules.Case;
          let workflowTypeIds = this.workflowTypeByModule?.filter(m => m.moduleId == this.module?.moduleId).map(m => m.workflowTypeId);
          this.dynamicFilterService.getWorkflowsByTypes({workflowTypesIds: workflowTypeIds}).subscribe(
            res => {
              this.workflowsSelectData = res;
              if(!this.usePreviousData){
                this.selectorForm.get('workflowSelect').setValue(0);
              }
            }
          );
        }else{
          this.module.moduleId = Modules.Alerts
          let workflowTypeIds = this.workflowTypeByModule?.filter(m => m.moduleId == this.module?.moduleId).map(m => m.workflowTypeId);
          this.dynamicFilterService.getWorkflowsByTypes({workflowTypesIds: workflowTypeIds}).subscribe(
            res => {
              this.workflowsSelectData = res;
              if(!this.usePreviousData){
                this.selectorForm.get('workflowSelect').setValue(0);
              }
            }
          );
        }
      }else{
        this.module = {moduleId: Modules.Alerts, description: this.selectedModule};
        let workflowTypeIds = this.workflowTypeByModule.filter(m => m.moduleId == this.module?.moduleId).map(m => m.workflowTypeId);
        this.dynamicFilterService.getWorkflowsByTypes({workflowTypesIds: workflowTypeIds}).subscribe(
          res => {
            this.workflowsSelectData = res; 
            this.selectorForm.get('workflowSelect').setValue(0);
          }
        );
      }
    }
  }

  createForms(): void {
    this.moduleSelectorForm = this.formBuilder.group({
      moduleSelect: [{value: this.returnSelectedModuleId(), disabled: this.isModuleSelectorDisabled()}],
    },
    {
      updateOn: 'change',
    });

    this.selectorForm = this.formBuilder.group({
      workflowSelect: [0],
    },
    {
      updateOn: 'change',
    });

    this.selectorStepForm = this.formBuilder.group({
      stepSelected: [0],
    },
    {
      updateOn: 'change',
    });
  }

  suscribeForms(): void {
    this.moduleSelectorForm.valueChanges
      .pipe(
        tap(value => this.onModuleSelected.emit(value.moduleSelect.description)),
        switchMap(value => {
          if(value.moduleSelect.description?.split('')?.length > 0){
            this.module = this.dynamicFiltersModules.find(m => m.description == value.moduleSelect.description);
          }
          this.stepsResult = [];
          this.complaintFormsResult = [];
          this.workflowsSelectData = [];
          if(this.selectorForm.get('workflowSelect').value !== 0){
            this.selectorForm.get('workflowSelect').setValue(0);
          }
          if(this.module?.moduleId === Modules.Complaints){
            return this.dynamicFilterService.getComplaintTypes();
          }else{
            let workflowTypeIds = this.workflowTypeByModule.filter(m => m.moduleId == this.module?.moduleId).map(m => m.workflowTypeId);
            return this.dynamicFilterService.getWorkflowsByTypes({workflowTypesIds: workflowTypeIds});
          }
        })
      )
      .subscribe((value) => {
        this.workflowsSelectData = value;
        if(this.module?.moduleId === Modules.Alerts){
          this.selectorForm.get('workflowSelect').setValue(this.currentWorkflowSelected);
        }
        
        if(this.selectedModule && !this.moduleSelectorForm?.get('moduleSelect').value.description){
          this.moduleSelectorForm?.get('moduleSelect')?.setValue({id: this.module.moduleId, description: this.module.description})
        }
      },
      err => {
        this.loadingData = false;
        console.log(err);
      });

    this.selectorForm.valueChanges.subscribe(
      values => {
        if(values.workflowSelect > 0){
          this.loadingData = true;
          this.onWorflowSelected.emit(values.workflowSelect);
          this.onStepSelected.emit(values.stepSelected);
          if(this.module.moduleId !== Modules.Complaints){
            this.dynamicFilterService.getStepsByWorkflowId(values.workflowSelect).subscribe(
              res => {
                res.map(x => {
                  x.formDto.questions.map(q => {
                    q.attachAllowed = false;
                    q.commentAllowed = false;
                  });
                });
                this.stepsResult = res;

                this.stepsResult.map(step => {
                  step.formDto.questions = step.formDto.questions.filter(x => {
                    if(x.questionTypeId !== 6 && x.questionTypeId !== 9){
                      return x;
                    }
                  });
                });                

                if(this.usePreviousData){
                  this.stepsResult?.map(step => {
                    if(this.prevFilters){
                      if(step.stepId === this.prevFilters.stepId){
                        step.formDto = this.prevFilters.formDto;
                      }
                    }
                  });
                }
                              
                if(this.stepsResult?.length == 1 && this.selectorStepForm.get('stepSelected').value < 1){
                  this.selectorStepForm.get('stepSelected').setValue(this.stepsResult[0].stepId);
                }
                this.loadingData = false;
              },
              err => {
                this.loadingData = false;
                console.log(err);
              }
            )
          }else{
            
            this.complaintFormsResult = [];
            this.workflowsSelectData.map((x: ComplaintType) => {
              if(x.id == values.workflowSelect){
                 this.dynamicFilterService.getComplaintForm(x.formTypeId, values.workflowSelect).subscribe(
                  res => {
                    res.questions.map(q => {
                      q.attachAllowed = false;
                      q.commentAllowed = false;
                    });
                    this.complaintFormsResult.push(res);
                    this.complaintFormsResult[0].questions = this.complaintFormsResult[0].questions.filter(x => {
                      if(x.questionTypeId !== 6 && x.questionTypeId !== 9){
                        return x;
                      }
                    });
                    
                    if(this.complaintFormsResult?.length == 1 && this.selectorStepForm.get('stepSelected').value < 1){
                      this.selectorStepForm.get('stepSelected').setValue(this.complaintFormsResult[0].stepId);
                    }
                    this.loadingData = false;
                  },
                  err => {
                    this.loadingData = false;
                    console.log(err);
                  });
              }
            });
          }
        }
      }
    );

    this.selectorStepForm.valueChanges.subscribe(
      values => {
        if(values.stepSelected > 0){
          this.onStepSelected.emit(values.stepSelected);
        }
      }
    );
  }

  isModuleSelectorDisabled(): boolean {
    if (!this.moduleSelectData?.length) {
      this.moduleSelectData?.push({id: 0, description: null});
      return true;
    }
    return false;
  }

  returnSelectedModuleId(): Item {
    if (!this.selectedModule) return null;

    const selectedModule = this.moduleSelectData?.find(m => m.description == this.selectedModule);
    return selectedModule ? selectedModule : null;
  }

  applyStepFilters(stepId){
    let formComponent: AppFormComponent = this.findFormComponentByStep(this.formComponents.toArray(), stepId);

    let stepFilteredObj: StepFilteredDto = {stepId: stepId, formDto: formComponent.formData};
    stepFilteredObj.formDto.questions.map(q => {
      formComponent.getSerializedValues().map(x => {
        if(q.id == x.questionId){
          q.answer = x.answer;
          q.dynamicFilterOperator = true;//Sentence AND by default
          if(q.questionTypeId == QUESTION_TYPES.DATE_RANGE){
            if(q.answer){
              let jsonAnswer = JSON.parse(q.answer);
              if(jsonAnswer?.value){
                if(jsonAnswer.value[3]){
                  q.questionOperatorId = Number(jsonAnswer.value[3]);
                  jsonAnswer.value?.splice(3,1);
                }
              }
              q.answer = JSON.stringify({value: jsonAnswer.value});
              if(jsonAnswer?.value){
                if(!jsonAnswer?.value[0] && !jsonAnswer?.value[1]){
                  q.answer = JSON.stringify({values: null});
                }
              }
            }
          }

          if(q.questionTypeId == QUESTION_TYPES.DATE_PICKER){
            if(q.answer){
              let jsonAnswer = JSON.parse(q.answer);
              if(jsonAnswer?.value){
                if(jsonAnswer?.value[1]){
                  q.questionOperatorId = Number(jsonAnswer.value[1]);
                  q.answer = JSON.stringify({value: jsonAnswer.value[0]});
                }
              }
            }
          }

          if(q.questionTypeId == QUESTION_TYPES.TEXT){
            // if(q.answer?.split('\"')[3]?.split('')?.length < 3){
            // let answer = q.answer?.split('\"value\":\"')[1];
            // answer = answer.split('"')[0];
            // if(!answer) return;
            // if(answer.split('')?.length < 3){
              // q.answer = "{\"value\":null}";
            // }
          }
        }
      });
    });
    let moduleFiltered = 0;
    
    if(this.module.moduleId == Modules.Complaints){
      moduleFiltered = Modules.Complaints;
    }else if(this.module.moduleId == Modules.Alerts){
      moduleFiltered = Modules.Alerts;
    }else if(this.module.moduleId == Modules.Case){
      moduleFiltered = Modules.Case;
    }
    
    const dataFiltered: DataFiltered = {
      stepFilteredDto: stepFilteredObj,
      moduleId: moduleFiltered
    }

    this.stepFiltered.emit(dataFiltered);
  }

  // function used to Escape special characters
  normalizeSpecialCharacters(answer: string): string {
    while (answer.includes('|') || answer.includes('&&')) {
      answer = answer.replace('|','');
      answer = answer.replace('&&','');
    }

    this.specialCharacters.forEach(char => {
      if (!answer.includes(char)) return;
      
      let modifiedAnswer = '';
      let normalizedChar = char == '%' ? `''${char}''` : `'${char}'`;

      answer.split(char).forEach((string, index, array) => {
        if (string == null || string == undefined) return;
        const isLastIndex = array?.length == index + 1;
        modifiedAnswer += isLastIndex ? string : string + normalizedChar;
      });
      answer = modifiedAnswer;
    })

    return answer;
  }

  clearFilters(stepId){
    let formComponent: AppFormComponent = this.findFormComponentByStep(this.formComponents.toArray(), stepId);
    let stepFilteredObj: StepFilteredDto = {stepId: stepId, formDto: formComponent.formData};
    formComponent.formData.questions.map(q => {q.answer = null});
    formComponent.form.reset();
    stepFilteredObj.formDto.questions.map(q => {
      formComponent.getSerializedValues().map(x => {
        if(q.id == x.questionId){
          q.answer = x.answer;
          q.dynamicFilterOperator = true;
          if(q.questionTypeId == QUESTION_TYPES.DATE_RANGE){
            q.answer = JSON.stringify({value: null});
          }
        }
      })
    });

    let moduleFiltered = 0;
    
    if(this.module.moduleId == Modules.Complaints){
      moduleFiltered = Modules.Complaints;
    }else if(this.module.moduleId == Modules.Alerts){
      moduleFiltered = Modules.Alerts;
    }else if(this.module.moduleId == Modules.Case){
      moduleFiltered = Modules.Case;
    }
    
    const dataFiltered: DataFiltered = {
      stepFilteredDto: stepFilteredObj,
      moduleId: moduleFiltered
    }

    this.onClearFilters.emit({filtersClear: true, dataStepFiltered: dataFiltered});
  }

  clearAllFilters(){
    this.formComponents.toArray().map(x => x.form.reset());
    if(this.stepsResult.length !== 1){
      this.selectorForm.reset();
      this.selectorStepForm.reset();
      if(this.selectedModule){
          if(this.selectedModule === DynamicFiltersModulesDescriptions.Complaint){
            this.module = {moduleId: Modules.Complaints, description: this.selectedModule};
            this.module.moduleId = Modules.Complaints;
          }else if(this.selectedModule === DynamicFiltersModulesDescriptions.Alerts){
            this.module = {moduleId: Modules.Alerts, description: this.selectedModule};
            this.module.moduleId = Modules.Alerts;
          }
        this.moduleSelectorForm.get('moduleSelect').setValue({id: null, description: ''});
      }else{
        this.moduleSelectorForm.get('moduleSelect').setValue({id: null, description: null});
      }
      this.complaintFormsResult = [];
      this.stepsResult = [];
    }
    this.usePreviousData = false;
    this.onClearAllFilters.emit(true);
    if(!this.selectedModule){
      this.reloadWorkflowData();
    }
  }

  findFormComponentByStep(formComponentsArray, stepId){
    let formComponent: AppFormComponent;
    formComponentsArray.find(el => {
      if(el['id']){
        if(el['id'] == stepId){
          // console.log(el);
          formComponent = el;
        }
      }
    });
    return formComponent;
  }
}
